<template>
<v-app>
  <HelloWorld
  :current_user=false
  >

  </HelloWorld>
</v-app>
</template>

<script>
import firebase from 'firebase'
import HelloWorld from './HelloWorld'

export default {
  name: 'Signin',
  data () {
    return {
      username: '',
      password: ''
    }
  },
  components:{HelloWorld},
  methods: {
      signIn:function(){
        const provider = new firebase.auth.GoogleAuthProvider()
        firebase.auth().signInWithPopup(provider).then(result => {
            alert('認証に成功しました');
            this.$router.push('/');
        }).catch(error => {
            this.errorMessage = error.message
            this.showError = true
        })
      }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1, h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
.signin {
  margin-top: 20px;

  display: flex;
  flex-flow: column nowrap;
  justify-content: center;
  align-items: center
}
input {
  margin: 10px 0;
  padding: 10px;
}
</style>